import type { AxiosError, AxiosRequestConfig } from 'axios';

import { getAccessToken, logout } from '../infra/auth';

export const authInterceptor = (
  request: AxiosRequestConfig,
): AxiosRequestConfig => {
  const accessToken = getAccessToken();
  if (!request.headers) {
    request.headers = {};
  }

  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
  }

  return request;
};

export const responseAuthErrorInterceptor = (
  error: AxiosError,
): Promise<never> => {
  if (error.response?.status === 401 || error.message === 'Network Error') {
    logout();
  }
  return Promise.reject(error);
};
